import { CreditCard } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import type { Subscription } from 'src/api/endpoints/storeApi.types';
import { Button } from 'src/components';
import { formatDate } from 'src/utils/formatDate';
import { subscriptionHelpers } from 'src/utils/subscriptionHelpers';
import { URLS } from 'src/utils/urls/urls';

import { Trans } from '@lingui/react/macro';
import { NotificationBanner } from '../../../components/NotificationBanner';

interface FreeConnectTermsAndConditionsProps {
  subscription?: Subscription;
}

export const PausedSubscriptionBanner = ({
  subscription,
}: FreeConnectTermsAndConditionsProps) => {
  if (
    subscriptionHelpers.isFreeConnect(subscription) ||
    !subscriptionHelpers.isDeactivated(subscription)
  ) {
    return null;
  }
  const cancelAtDate = formatDate(
    subscription.paymentInformation.cancellationAt
  );
  if (subscription.access.canChangePaymentInformation) {
    return (
      <NotificationBanner>
        <div>
          <Typography variant="body-md" fontWeight="bold" as="h3">
            <Trans>Your subscription is on hold</Trans>
          </Typography>
          <Typography variant="body-md" className="mt-8" as="p">
            <Trans>
              There was an error with your payment, and your subscription is on
              hold. Your team can still access their files, but subscription
              benefits are unavailable. To restore access, please change your
              card or update your payment details. Your subscription will be
              canceled{' '}
              <Typography as="span" variant="body-md" fontWeight="bold">
                {cancelAtDate}
              </Typography>
              , if you don&apos;t update your payment details.
            </Trans>
          </Typography>
          <Button className="mt-24" as={'a'} to={URLS.SUBSCRIPTION_PAYMENT}>
            <CreditCard />
            <span>
              <Trans>Update payment</Trans>
            </span>
          </Button>
        </div>
      </NotificationBanner>
    );
  }
  return (
    <NotificationBanner>
      <div>
        <Typography variant="body-md" fontWeight="bold" as="h3">
          <Trans>Your company&apos;s subscription is on hold</Trans>
        </Typography>
        <Typography variant="body-md" className="mt-8" as="p">
          <Trans>
            Your subscription features are unavailable, but you can still access
            your files. Please ask your admin to update their payment details.
          </Trans>
        </Typography>
      </div>
    </NotificationBanner>
  );
};
